/* eslint-disable */
/* Code generated by ng-openapi-gen DO NOT EDIT. */

import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { StrictHttpResponse } from '../../strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { PigDto } from '../../models/pig-dto';

export interface PigControllerFindById$Params {
  id: string;
}

export function pigControllerFindById(http: HttpClient, rootUrl: string, params: PigControllerFindById$Params, context?: HttpContext): Observable<StrictHttpResponse<PigDto>> {
  const rb = new RequestBuilder(rootUrl, pigControllerFindById.PATH, 'get');
  if (params) {
    rb.path('id', params.id, {});
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'application/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as StrictHttpResponse<PigDto>;
    })
  );
}

pigControllerFindById.PATH = '/api/pig/{id}';
